<template>
  <Page>
    <div class="container container--tiny">
      <h1 class="h2 h-margin-bottom">
        {{ $t('auth/login') }}
      </h1>
      <AuthLoginForm />
      <h3 class="h-margin-top-xl">
        {{ $t('register/no-customer-yet') }}
      </h3>
      <p v-html="$t('register/welcome-submessage')" />
      <Btn
        full-width="all"
        shape="pill"
        class="h-margin-top"
        :to="{ name: $lang + '-register' }">
        {{ $t('register/create-account') }}
      </Btn>
    </div>
  </Page>
</template>
<script setup>
await useI18n(['register', 'auth'])
const { $lang } = useNuxtApp()
const route = useRoute()
const router = useRouter()
const authStore = useAuthStore()

if (authStore.loggedIn) {
  router.replace({ path: route.query.redirect ? route.query.redirect : `/${$lang}/account/profile` })
}

useHead({
  title: $t('auth/login')
})

</script>
